module.exports = __webpack_public_path__ + "static/media/effect_09.f4ccc9b7.png";